import { createAsyncThunk } from "@reduxjs/toolkit";

import giacenzeAPI from "../../services/giacenzeAPI";
import { addGiacenze, addGiacenzeId, apiRequestFailure, apiRequestStart, apiRequestSuccess, deleteGiacenze, enumRequestFailure, enumRequestStart, enumRequestSuccess, setFormato, setGiacenze, setMotivazione, setUm, updateGiacenze } from "./giacenzeSlice";

export const fetchGiacenze = createAsyncThunk(
    "giacenzeData/fetchGiacenze",
    async (id, { dispatch }) => {
      dispatch(apiRequestStart());
      try {
        const response = await giacenzeAPI.getAllGiacenze(id);
        dispatch(setGiacenze(response.data.data));
        // console.log(response.data.data, 'data of fetch');
        
        dispatch(apiRequestSuccess());
        return response.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to fetch prodotti.";
        dispatch(apiRequestFailure(errorMessage));
        throw new Error(errorMessage);
      }
    }
  );

  export const singleGiacenza = createAsyncThunk(
    "giacenze/fetchSingleGiacenze",
    async (giacenzeId, {dispatch}) => {
      dispatch(apiRequestStart());
      try {
        const response = await giacenzeAPI.getSingleGiacenza(giacenzeId);
        // Make sure we're storing the data properly in state
        dispatch(addGiacenzeId([response.data.data]));
        
        // Add logging to debug
        // console.log("Single Prodotto data:", response.data.data);
        
        dispatch(apiRequestSuccess());
        return response.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to fetch single prodotto.";
        dispatch(apiRequestFailure(errorMessage));
        throw new Error(errorMessage);
      }
    }
  )

  export const createGiacenza = createAsyncThunk(
    "giacenzaData/createGiacenza",
    async (payload, { dispatch }) => {
      dispatch(apiRequestStart());
      try {
        const response = await giacenzeAPI.createGiacenza(payload);
        dispatch(addGiacenze(response.data.data));      
        dispatch(apiRequestSuccess());
        return response.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to create prodotto.";
        dispatch(apiRequestFailure(errorMessage));
        throw new Error(errorMessage);
      }
    }
  );
  export const updateGiacenzaData = createAsyncThunk(
    "giacenzaData/updateGiacenza",
    async ({ id, data }, { dispatch }) => {
      dispatch(apiRequestStart());
      try {
        const response = await giacenzeAPI.updateGiacenza(id, data);
        dispatch(updateGiacenze(response.data.data));
        dispatch(apiRequestSuccess());
        return response.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to update prodotto.";
        dispatch(apiRequestFailure(errorMessage));
        throw new Error(errorMessage);
      }
    }
  );

  export const deleteGiacenzaData = createAsyncThunk(
    "giacenzaData/deleteGiacenza",
    async (id, { dispatch }) => {
      dispatch(apiRequestStart());
      try {
        await giacenzeAPI.deleteGiacenza(id);
        dispatch(deleteGiacenze(id));
        dispatch(apiRequestSuccess());
        return id;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to delete prodotto.";
        dispatch(apiRequestFailure(errorMessage));
        throw new Error(errorMessage);
      }
    }
  );

  export const fetchUm = createAsyncThunk(
    "giacenzaData/fetchUm",
    async (_, { dispatch }) => {
      dispatch(enumRequestStart("um"));
      try {
        const response = await giacenzeAPI.getUm();
        // console.log("Um API Response:", response.data.data);
        dispatch(setUm(response.data.data)); // Use setTipologia action instead of selectTipologia
        dispatch(enumRequestSuccess("um"));
        return response.data.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to fetch um.";
        dispatch(
          enumRequestFailure({
            enumType: "um",
            error: errorMessage,
          })
        );
        throw new Error(errorMessage);
      }
    }
  );
  

  export const fetchFormato = createAsyncThunk(
    "giacenzaData/fetchFormato",
    async (_, { dispatch }) => {
      dispatch(enumRequestStart("formato"));
      try {
        const response = await giacenzeAPI.getFormato();
        dispatch(setFormato(response.data.data));
        dispatch(enumRequestSuccess("formato"));
        return response.data.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to fetch formato.";
        dispatch(
          enumRequestFailure({
            enumType: "formato",
            error: errorMessage,
          })
        );
        throw new Error(errorMessage);
      }
    }
  );
  
  export const fetchMotivazione = createAsyncThunk(
    "giacenzaData/fetchMotivazione",
    async (_, { dispatch }) => {
      dispatch(enumRequestStart("motivazione"));
      try {
        const response = await giacenzeAPI.getMotivazione();
        dispatch(setMotivazione(response.data.data));
        dispatch(enumRequestSuccess("motivazione"));
        return response.data.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to fetch motivazione.";
        dispatch(
          enumRequestFailure({
            enumType: "motivazione",
            error: errorMessage,
          })
        );
        throw new Error(errorMessage);
      }
    }
  );
  